const config = () => ({
  scriptUrl:
    'https://www.swisslos.ch/media/swisslos/sporttip/sporttip_widgets/dist/bridge.min.js',
})

export type configType = ReturnType<typeof config>
export default config
